export const CERTIFICATIONS = [
  {
    id: "bnsp-web",
    title: "Junior Web Programmer",
    issuer: "BNSP (Badan Nasional Sertifikasi Profesi)",
    date: "Aug 2025 - 2028", //[cite: 7]
    image: "/images/cert_bnsp_web.png",
    link: "#",
  },
  {
    id: "bnsp-mobile",
    title: "Junior Mobile Programmer",
    issuer: "BNSP (Badan Nasional Sertifikasi Profesi)",
    date: "Dec 2023 - 2026", //[cite: 7]
    image: "/images/cert_bnsp_mobile.png",
    link: "#",
  },
];